import { useQuery } from "@apollo/client";
import { ProfileSkeleton } from "@/components/Skeleton";
import { UNIVERSITY_QUERY } from "@/pages/education/universities/[universityId]/queries";
import { UniversitiesQuery } from "@/pages/education/universities/types";
import ObjectHeading from "@/components/ObjectHeading";
import { getUniversityEnrollmentCount } from "@/pages/education/universities/_utils";

export interface MobileUniversityOverviewProps {
  universityId: string;
}

export default function MobileUniversityOverview({ universityId }: MobileUniversityOverviewProps) {
  const { data, loading, error } = useQuery<UniversitiesQuery>(UNIVERSITY_QUERY, {
    variables: { legacyId: universityId }
  });

  if (loading) return <ProfileSkeleton />;
  if (error) return <div>Error loading university details</div>;
  if (!data?.universities?.[0]) return <div>University not found</div>;

  const university = data.universities[0];
  const { name, address, activeStudentCount, alumniStudentCount, logoUrl, studentProgramSummary } = university;
  const addressParts = [address?.city, address?.state].filter(Boolean);
  const addressString = addressParts.length > 0 ? addressParts.join(", ") : undefined;
  const enrollmentCount = getUniversityEnrollmentCount({ activeStudentCount, studentProgramSummary });
  const studentCountString = `${enrollmentCount} Enrollments, ${alumniStudentCount} Alumni`;

  return (
    <div
      className="bg-sys-brand-surface pb-4 border-b border-sys-brand-outline-variant"
      data-testid="mobile-university-overview"
    >
      <ObjectHeading
        title={name}
        iconName="school"
        variant="landing-page"
        imageUrl={logoUrl || undefined}
        metaData={[
          ...(addressString ? [{ text: addressString, label: "Location" }] : []),
          { text: studentCountString, label: "Enrollment" }
        ]}
      />
    </div>
  );
}
